import { memo } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import _join from 'lodash/join';
// Local files
import { StyledListItem } from './Item.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';

const Item = ({ id, clinician, emails }) => { 
  const {setSuperbillGoalDrawer} = useApp();
  const fullName = `${clinician.first_name} ${clinician.last_name}`
  
  const handleClick = () => setSuperbillGoalDrawer({ open: true, edit: true, id });

  return (
    <StyledListItem disablePadding>
      <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Typography noWrap>{`Clinician: ${fullName}`}</Typography>
        <Typography noWrap>Emails: {_join(emails, ', ')}</Typography>
      </Box>
      <Button variant='contained' onClick={handleClick} sx={{ mr: 1 }}>Edit</Button>
    </StyledListItem>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);